/**
 * Public barrel export for the FilterChip component
 * @module features/scouting/components/FilterChip
 */

export { default } from "./FilterChipContainer";
export type { FilterOption } from "@/types/filter";
